import { render, staticRenderFns } from "./AttachmentAttachForm.vue?vue&type=template&id=5e312558&"
import script from "./AttachmentAttachForm.vue?vue&type=script&lang=js&"
export * from "./AttachmentAttachForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports